export const COURSE_PAUSE_REQUEST_DURATION = [
  {
    value: 1,
    label: '1 Month',
  },
  {
    value: 2,
    label: '2 Months',
  },
  {
    value: 3,
    label: '3 Months',
  },
  {
    value: 4,
    label: '4 Months',
  },
  {
    value: 5,
    label: '5 Months',
  },
  {
    value: 6,
    label: '6 Months',
  },
];
